module.exports = __webpack_public_path__ + "img/14.e7e05df2.jpg";